import type {
  ProgressBarSlots as ProgressBarBaseSlots,
  ProgressBarBaseProps,
  ProgressBarBaseState,
} from '@fluentui/react-progress';

export type ProgressBarSlots = ProgressBarBaseSlots;

/**
 * ProgressBar Props
 */
export type ProgressBarProps = ProgressBarBaseProps;

/**
 * State used in rendering ProgressBar
 */
export type ProgressBarState = ProgressBarBaseState & {
  root: {
    'data-indeterminate'?: string;
  };
};
